module.exports = __webpack_public_path__ + "img/jubao.dafb50f2.png";